import React, { useState } from "react";
import Login from "./Login";
import { useNavigate } from "react-router-dom";
import * as authServices from "../services/auth.service";
const LoginContainer = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({
    form: {
      docIdentidad: "",
      clave: "",
    },
    loading: false,
    error: null,
  });
  const handleChange = (e) => {
    setState({
      form: {
        ...state.form,
        [e.target.name]: e.target.value,
      },
      loading: false,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setState({
        form: {
          ...state.form,
        },
        loading: true,
      });
      if (state.form.docIdentidad && state.form.clave) {
        const res = await authServices.login(
          state.form.docIdentidad,
          state.form.clave
        );
        let json = await res.data;
        localStorage.setItem("token", JSON.stringify(json.token));
        setState({
          form: {
            ...state.form,
          },
          loading: false,
        });
        if (json.token) {
          if (window.location.pathname === '/') {
            navigate("/main", { state: json });
          } else {
            navigate("/main", { state: json });
            window.location.reload();
          }
        } else {
          navigate("/", { state: { error: json.error } });
        }
      } else {
        setState({
          form: {
            ...state.form,
          },
          loading: false,
        });
        navigate("/", {
          state: { error: "Favor ingresar usuario y clave." },
        });
      }
    } catch (error) {
      console.log(error);
      setState({
        form: {
          ...state.form,
        },
        loading: false,
        error,
      });
      navigate("/", {
        state: { error: "Ocurrio un error en el proceso." },
      });
    }
  };
  const token = window.localStorage.getItem("token");
  if (token) {
    window.localStorage.removeItem("token");
  }
  return (
    <Login form={state.form} onChange={handleChange} onSubmit={handleSubmit} />
  );
};
export default LoginContainer;